import { render, staticRenderFns } from "./CarteraAgentes.vue?vue&type=template&id=5b10fb94"
import script from "./CarteraAgentes.vue?vue&type=script&lang=js"
export * from "./CarteraAgentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports